import Model from '@/Models/Contracts/Model';
import Formula from '@/Services/Formula/Formula';
export default class FieldsModel extends Model {
    // eslint-disable-next-line
    constructor(attr = null, shouldRecalculate = true) {
        var _a, _b, _c, _d, _e;
        let props = [];
        if (attr) {
            // eslint-disable-next-line
            // @ts-ignore
            props = [attr];
        }
        super(...props);
        const attributes = attr !== null && attr !== void 0 ? attr : null;
        const storeId = (_d = (_b = (_a = attributes === null || attributes === void 0 ? void 0 : attributes.store) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : (_c = attributes === null || attributes === void 0 ? void 0 : attributes.budget) === null || _c === void 0 ? void 0 : _c.store_id) !== null && _d !== void 0 ? _d : attributes === null || attributes === void 0 ? void 0 : attributes.store_id;
        this._store = (_e = storeManager.getStore(storeId)) !== null && _e !== void 0 ? _e : null;
        // Remove values that should not be sent on update
        if (this.values) {
            if (Object.prototype.hasOwnProperty.call(this.values, 'id')) {
                delete this.values.id;
            }
            if (Object.prototype.hasOwnProperty.call(this.values, 'type')) {
                delete this.values.type;
            }
        }
        // If no values exist generate defaults
        if (!(attr === null || attr === void 0 ? void 0 : attr.values)) {
            const values = {};
            storeManager.getFields(this._store).forEach(field => {
                values[field.key] = {
                    value: null,
                    percent: null,
                    formula: field.formula,
                };
            });
            this.values = values;
        }
        // Used for entities that should not recalculate, like accumulated entities since they are calculated outside this
        // A non-model entity could have been better separation of concerns for this use case
        if (shouldRecalculate) {
            for (const key in this.values) {
                const field = storeManager.getField(key, this._store);
                this.values[key]._dependents = this.calculateDependents(key);
                // Add a proxy to intercept setters and recalculate chain of dependents
                this.values[key] = new Proxy(this.values[key], {
                    set: (target, p, value) => {
                        target[p] = value;
                        const [newValue, newPercent] = this.getCalculatedValues(field);
                        if (p === 'value') {
                            target.percent = newPercent;
                        }
                        if (p === 'percent') {
                            target.value = newValue;
                        }
                        if (p === 'value' || p === 'percent') {
                            target._dependents.forEach(field => {
                                this.recalculateField(field);
                            });
                        }
                        return true;
                    }
                });
            }
        }
        // Defines default filter for models to only get model type from endpoint
        if (!attr
            && typeof this.getType() === 'string'
            && this.getType() !== '') {
            this.where('type', this.getType());
        }
    }
    save() {
        // Reassign to remove proxy
        this.values = Object.assign({}, this.values);
        for (const key in this.values) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.values[key] = {
                value: this.values[key].value,
                percent: this.values[key].percent,
                formula: this.values[key].formula,
            };
        }
        return super.save();
    }
    resource() {
        return 'profit-and-losses';
    }
    getType() {
        return null;
    }
    get header() {
        return moment.utc(this.date).format('D. MMMM YYYY');
    }
    copyValues(model) {
        this.values = _.cloneDeep(model.values);
    }
    copyFormulas(model) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (typeof model.values !== 'object' || model.values === null) {
            console.error('model.values is not a valid object');
            return;
        }
        this.values = Object.keys(model.values).reduce((acc, key) => {
            const value = model.values[key];
            if (value && value.formula !== null) {
                const clonedValue = _.cloneDeep(value);
                Object.keys(clonedValue).forEach(prop => {
                    if (prop !== 'formula') {
                        clonedValue[prop] = null;
                    }
                });
                acc[key] = clonedValue;
            }
            return acc;
        }, {});
        /*this.values = Object.keys(model.values).reduce((acc, key) => {
            const value = model.values[key];
            if (value && value.formula !== null) {
                acc[key] = {
                    value: null,
                    formula: _.cloneDeep(value.formula),
                    percent: null,
                    _dependents: _.cloneDeep(value._dependents)
                };
            }
            return acc;
        }, {} as Record<string, FieldValuesDefinition>);*/
    }
    /**
     * Adds other models to current model.
     * @param model
     * @param shouldRecalculate
     */
    add(model, shouldRecalculate = true) {
        if (!Array.isArray(model)) {
            model = [model];
        }
        model.forEach(model => {
            for (const key in this.values) {
                const otherValue = model.value(key);
                if (otherValue) {
                    const currentValue = this.value(key);
                    this.setValue(key, currentValue ? currentValue + otherValue : otherValue);
                }
            }
        });
        const netSalesProduct = this.value('net_sales_product');
        for (const key in this.values) {
            const value = this.value(key);
            if (!netSalesProduct || !value) {
                continue;
            }
            const percent = (value / netSalesProduct) * 100;
            this.setPercent(key, percent);
        }
        if (shouldRecalculate) {
            this.recalculate();
        }
    }
    /**
     * Returns value by key
     * @param key
     */
    value(key) {
        if (!this.values || !Object.hasOwnProperty.call(this.values, key)) {
            return null;
        }
        return this.getValue(key);
    }
    /**
     * Returns percent by key
     * @param key
     */
    percent(key) {
        if (!this.values || !Object.hasOwnProperty.call(this.values, key)) {
            return null;
        }
        return this.getPercent(key);
    }
    recalculate() {
        storeManager.getFields(this._store).forEach(field => {
            if (field.calculated_by !== CalculatedBy.FORMULA) {
                this.recalculateField(field);
            }
        });
        this.recalculateFormulaFields();
    }
    recalculateFormulaFields() {
        storeManager.getFields(this._store).forEach(field => {
            this.recalculateField(field);
        });
    }
    recalculateField(field) {
        const [value, percent] = this.getCalculatedValues(field);
        this.values[field.key].value = value;
        this.values[field.key].percent = percent;
    }
    getValue(key) {
        return this.values && Object.hasOwnProperty.call(this.values, key) ? this.values[key].value : null;
    }
    setValue(key, value) {
        this.prepareValues(key);
        this.values[key].value = value;
    }
    getPercent(key) {
        return this.values && Object.hasOwnProperty.call(this.values, key) ? this.values[key].percent : null;
    }
    setPercent(key, value) {
        this.prepareValues(key);
        this.values[key].percent = value;
    }
    getFormula(key) {
        return this.values && Object.hasOwnProperty.call(this.values, key) ? this.values[key].formula : null;
    }
    setFormula(key, value) {
        this.prepareValues(key);
        this.values[key].formula = value;
    }
    getCalculatedValues(field) {
        if (field.calculated_by === CalculatedBy.VALUE) {
            let percent = null;
            const value = this.getValue(field.key);
            const netSalesProduct = this.value('net_sales_product');
            if (typeof value === 'number' && typeof netSalesProduct === 'number') {
                percent = (value / netSalesProduct) * 100;
            }
            return [value, percent];
        }
        if (field.calculated_by === CalculatedBy.PERCENT) {
            const percent = this.getPercent(field.key);
            let value = null;
            const netSalesProduct = this.value('net_sales_product');
            if (typeof percent === 'number' && typeof netSalesProduct === 'number') {
                value = (netSalesProduct / 100) * percent;
            }
            return [value, percent];
        }
        if (field.calculated_by === CalculatedBy.FORMULA) {
            const formula = this.getFormula(field.key);
            if (!Array.isArray(formula)) {
                throw new Error('Fields calculated by formula must have a formula attached to them.');
            }
            const value = this.getFormulaResult(formula);
            const netSalesProduct = this.value('net_sales_product');
            const percent = netSalesProduct && value ? (value / netSalesProduct) * 100 : null;
            return [value, percent];
        }
        return [null, null];
    }
    getFormulaResult(formula, debug = false) {
        return Formula.fromArray(formula, debug).getResult(this);
    }
    prepareValues(key) {
        if (!this.values) {
            this.values = {};
        }
        if (!Object.hasOwnProperty.call(this.values, key)) {
            const field = storeManager.getField(key, this._store);
            this.values[key] = {
                value: null,
                percent: null,
                formula: field.formula,
                _dependents: this.calculateDependents(key),
            };
        }
    }
    calculateDependents(key) {
        const dependents = [];
        for (const otherKey in this.values) {
            const otherField = storeManager.getField(otherKey, this._store);
            let found = false;
            if ((otherField === null || otherField === void 0 ? void 0 : otherField.calculated_by) === CalculatedBy.FORMULA) {
                const formula = Formula.fromArray(this.values[otherKey].formula);
                formula.parts.forEach(entry => {
                    if (!found
                        && typeof entry === 'object'
                        && Object.prototype.hasOwnProperty.call(entry, 'type')
                        && entry.type === 'field') {
                        const field = storeManager.getFieldByNumber(entry.value, this._store);
                        if (field.key === key) {
                            dependents.push(otherField);
                            found = true;
                        }
                    }
                });
            }
        }
        return dependents;
    }
}
